(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["darzuna-home-v3"] && !Shopify.designMode) return;
  try {
    
  const heroMotion = window.matchMedia('(prefers-reduced-motion: no-preference)');
  let heroFrame = 0;

  function updateHeroParallax() {
    heroFrame = 0;
    if (!heroMotion.matches) return;

    for (const hero of document.querySelectorAll('[data-dz-hero]')) {
      const bounds = hero.getBoundingClientRect();
      const media = hero.querySelector('.dz-hero__media');
      if (!media || bounds.bottom <= 0 || bounds.top >= window.innerHeight) continue;

      media.setAttribute('data-dz-parallax', '');
      const travel = parseFloat(getComputedStyle(media).getPropertyValue('--dz-hero-travel')) || 0;
      const progress = Math.max(0, Math.min(1, (-bounds.top * 1.65) / bounds.height));
      media.style.setProperty('--dz-hero-offset', `${Math.round(progress * travel)}px`);
    }
  }

  function scheduleHeroParallax() {
    if (heroMotion.matches && !heroFrame) heroFrame = requestAnimationFrame(updateHeroParallax);
  }

  if (document.querySelector('[data-dz-hero]')) {
    document.addEventListener('scroll', scheduleHeroParallax, { capture: true, passive: true });
    window.addEventListener('resize', scheduleHeroParallax, { passive: true });
    heroMotion.addEventListener('change', scheduleHeroParallax);
    document.addEventListener('shopify:section:load', scheduleHeroParallax);
    scheduleHeroParallax();
  }
  const honeySource = document.querySelector('[data-dz-honey-source] img');
  const honeyFooter = document.querySelector('.dz-footer');
  const honeyLanding = honeyFooter?.querySelector('.dz-footer__grid nav:nth-of-type(2)');
  const honeyTemplate = document.querySelector('[data-dz-honey-template]');

  if (honeySource && honeyLanding && honeyTemplate) {
    const art = honeyTemplate.content.cloneNode(true);
    const pool = art.querySelector('.dz-honey-pool');
    const stream = art.querySelector('.dz-honey-stream');
    const drops = [...stream.querySelectorAll('img')];
    honeyLanding.append(pool);
    document.body.append(stream);

    let started = false;
    let animations = [];
    let frame = 0;

    function measureHoneyPath() {
      frame = 0;
      animations.forEach((animation) => animation.cancel());
      animations = [];
      const imageWidth = honeySource.naturalWidth || Number(honeySource.getAttribute('width'));
      const imageHeight = honeySource.naturalHeight || Number(honeySource.getAttribute('height'));
      if (!imageWidth || !imageHeight) return;

      const origin = honeySource.getBoundingClientRect();
      const factor = Math.max(origin.width / imageWidth, origin.height / imageHeight);
      const photoWidth = imageWidth * factor;
      const photoHeight = imageHeight * factor;

      // The tip of the real honey thread, measured on the uncropped collection photo.
      const sourceX = origin.left + (origin.width - photoWidth) / 2 + photoWidth * .423;
      const sourceY = origin.top + (origin.height - photoHeight) / 2 + photoHeight * .68;
      const footerStart = honeyFooter.getBoundingClientRect().left;
      const footerX = sourceX - footerStart;
      const poolLeft = Math.max(0, Math.min(footerX - pool.offsetWidth * .53, honeyFooter.clientWidth - pool.offsetWidth));
      pool.style.marginLeft = `${footerStart + poolLeft - honeyLanding.getBoundingClientRect().left}px`;
      pool.style.setProperty('--dz-honey-impact-x', `${footerX - poolLeft}px`);
      if (!started || !heroMotion.matches) return;

      const landing = pool.querySelector('img').getBoundingClientRect();
      const layer = stream.getBoundingClientRect();
      const x = sourceX - layer.left;
      const y0 = sourceY - layer.top;
      const y1 = landing.top + landing.height * .52 - layer.top;
      const distance = y1 - y0;
      if (distance < 100) return;

      const fall = Math.min(12000, Math.max(6800, distance * 3.1));
      const interval = fall / drops.length;
      const dropHeight = drops[0].offsetHeight;
      const pose = (y, width, height) =>
        `translate3d(${x}px, ${y}px, 0) translateX(-50%) scale(${width}, ${height})`;

      drops.forEach((drop, index) => {
        animations.push(drop.animate([
          { offset: 0, opacity: 0, transform: pose(y0, .28, .18), easing: 'ease-out' },
          { offset: 510 / fall, opacity: 1, transform: pose(y0, .94, .79), easing: 'ease-in' },
          { offset: 750 / fall, opacity: 1, transform: pose(y0, .82, 1.14), easing: 'ease-in' },
          { offset: 1030 / fall, opacity: 1, transform: pose(y0 + distance * .02, .94, 1.03) },
          { offset: 1 - 120 / fall, opacity: 1, transform: pose(y1 - dropHeight, 1, 1) },
          { offset: 1, opacity: 0, transform: pose(y1 - dropHeight * .18, 1.24, .18) },
        ], { duration: fall, delay: -index * interval, iterations: Infinity }));
      });

      animations.push(pool.querySelector('.dz-honey-ripple').animate([
        { opacity: 0, transform: 'translate(-50%, -50%) scale(.55)' },
        { offset: .08, opacity: .72 },
        { offset: .25, opacity: 0, transform: 'translate(-50%, -50%) scale(1.7)' },
        { opacity: 0 },
      ], { duration: interval, delay: interval - 120, iterations: Infinity }));
    }

    function scheduleHoneyPath() {
      if (!frame) frame = requestAnimationFrame(measureHoneyPath);
    }

    function startHoneyStream() {
      if (honeySource.getBoundingClientRect().top >= window.innerHeight) return;
      started = true;
      window.removeEventListener('scroll', startHoneyStream);
      scheduleHoneyPath();
    }

    window.addEventListener('scroll', startHoneyStream, { passive: true });
    heroMotion.addEventListener('change', scheduleHoneyPath);
    window.addEventListener('resize', scheduleHoneyPath, { passive: true });
    honeySource.addEventListener('load', scheduleHoneyPath);
    if ('ResizeObserver' in window) new ResizeObserver(scheduleHoneyPath).observe(document.body);
    startHoneyStream();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["darzuna-page"]) return;
  try {
    
function setAzzahraProductContext(root = document) {
  const product = new URL(window.location.href).searchParams.get('producto')?.trim().slice(0, 180);
  if (!product) return;
  root.querySelectorAll('[data-dz-contact-product]').forEach((field) => {
    field.querySelector('input').value = product;
    field.hidden = false;
  });
}
setAzzahraProductContext();
document.addEventListener('shopify:section:load', (event) => setAzzahraProductContext(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["darzuna-product-suggestions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dz-product-suggestions')) {
  customElements.define('dz-product-suggestions', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.observers = [];
      this.querySelectorAll('[data-dz-rail]').forEach((rail) => {
        const track = rail.querySelector('[data-dz-track]');
        const controls = rail.querySelector('[data-dz-controls]');
        const buttons = [...controls.querySelectorAll('button')];
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max < 3;
          buttons[0].disabled = track.scrollLeft < 3;
          buttons[1].disabled = track.scrollLeft >= max - 3;
        };
        buttons.forEach((button) => button.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({left: Number(button.dataset.dzDirection) * track.clientWidth * .9, behavior: reducedMotion ? 'instant' : 'smooth'});
        }, {signal: this.controller.signal}));
        track.addEventListener('scroll', update, {passive: true, signal: this.controller.signal});
        const observer = new ResizeObserver(update);
        observer.observe(track);
        this.observers.push(observer);
        update();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observers?.forEach((observer) => observer.disconnect());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["darzuna-product"]) return;
  try {
    
function showVariantPhoto(root, option) {
  if (!option?.dataset.imageId) return;
  const track = root.querySelector('[data-dz-gallery]');
  const photo = track?.querySelector(`[data-dz-image-id="${option.dataset.imageId}"]`);
  if (!photo) return;

  track.prepend(photo);
  track.scrollLeft = 0;
  const links = [...root.querySelectorAll('[data-dz-photo-link]')];
  const selected = links.find((link) => link.hash === '#' + photo.id);
  if (!selected) return;

  const labels = links.map((link) => link.getAttribute('aria-label'));
  selected.parentElement.prepend(selected);
  [...selected.parentElement.children].forEach((link, index) => {
    link.setAttribute('aria-label', labels[index]);
    if (index === 0) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
  });
}

function showInitialVariantPhotos(scope) {
  for (const select of scope.querySelectorAll('[data-dz-variant]')) {
    showVariantPhoto(select.closest('[data-dz-product]'), select.selectedOptions[0]);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => showInitialVariantPhotos(document), { once: true });
} else {
  showInitialVariantPhotos(document);
}
document.addEventListener('shopify:section:load', (event) => showInitialVariantPhotos(event.target));

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-dz-variant]')) return;
  const root = event.target.closest('[data-dz-product]');
  const option = event.target.selectedOptions[0];
  const available = option.dataset.available === 'true';
  root.querySelector('[data-dz-price]').textContent = option.dataset.price;
  const button = root.querySelector('[data-dz-add]');
  button.disabled = !available;
  button.textContent = available ? root.dataset.addLabel : root.dataset.unavailableLabel;
  root.querySelector('[data-dz-quantity]').disabled = !available;
  root.querySelector('[data-dz-unavailable]').hidden = available;
  showVariantPhoto(root, option);
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-dz-photo-link]');
  if (!link || !window.matchMedia('(max-width: 640px)').matches) return;
  const track = link.closest('.dz-detail__media').querySelector('[data-dz-gallery]');
  const photo = [...track.children].find((figure) => link.hash === '#' + figure.id);
  if (!photo) return;
  event.preventDefault();
  const left = photo.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  track.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
});
document.addEventListener('scroll', (event) => {
  const track = event.target;
  if (!(track instanceof Element) || !track.matches('[data-dz-gallery]')) return;
  const start = track.getBoundingClientRect().left;
  let index = 0;
  let distance = Infinity;
  Array.from(track.children).forEach((photo, position) => {
    const next = Math.abs(photo.getBoundingClientRect().left - start);
    if (next < distance) { distance = next; index = position; }
  });
  track.closest('.dz-detail__media').querySelectorAll('[data-dz-photo-link]').forEach((link, position) => {
    if (position === index) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
  });
}, { capture: true, passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
